module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAQAAAD9CzEMAAAAoklEQVR4Ae2WIQgCQRQFB1EwWQSL+aLBag9mk73Zi/ZiD/ZoMV8PVoPxskksFsOBrDywcxfecQt/pjOwy/6/BEEQ9JozE5qQ/rYm8WDlDSS+HBk6A/JG4QzIDztvQJZMnQH5ZO0NyBNjZ0BWLJwBWbNn4AzIK3NnQL7ZuAPbbI+o5uC85Ipltg/t5R0VJbNsx/WdwrsyR9ku/Yv72xIEQdAdP/+/KuYq1XHGAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/Screens/Dashboard/baseline_skip_next_black_24dp.png
// module id = 128
// module chunks = 0